import { getAuthentication } from '@/hooks/useAuthentication';
import OnBoardingContainer from '@/components/on-boarding';
import { onInitOnBoarding } from '@/services/on-boarding/onboarding.service';
import { useCallback, useEffect } from 'react';
import { useOnBoardingV5 } from '../hooks/useOnBoardingV5';
import { useParams, Navigate } from 'react-router-dom';
export default function OnBoardingStep() {
  const { stepNumber } = useParams<{ stepNumber: string }>();
  const step = Number(stepNumber) || 1;

  const { page, currentStep, totalSteps, isLastStep, completeStep, onClickOnBoardingCompleted } = useOnBoardingV5(step);

  const isFirstStep = step === 1;

  const onInit = useCallback(async () => {
    const { user } = getAuthentication();
    if (!user?.id) return;
    await onInitOnBoarding(user.id);
  }, []);

  useEffect(() => {
    if (isFirstStep) {
      onInit();
    }
  }, [isFirstStep, onInit]);

  if (totalSteps === 0) {
    return <Navigate to="/" replace />;
  }

  if (step < 1 || step > totalSteps) {
    const { user } = getAuthentication();
    if (user?.id) {
      localStorage.setItem(`current-step-${user.id}`, '/on-boarding/step/1');
    }
    return <Navigate to="/on-boarding/step/1" replace />;
  }

  const handleClick = isLastStep ? onClickOnBoardingCompleted : () => completeStep();

  return (
    <OnBoardingContainer
      page={page}
      image={currentStep?.image?.url || ''}
      step={step - 1}
      title={currentStep?.title || ''}
      description={currentStep?.description || ''}
      button={{
        text: currentStep?.button?.text || '',
        onClick: handleClick,
      }}
    />
  );
}
